import { render, staticRenderFns } from "./ViewModule.vue?vue&type=template&id=bb15091c"
import script from "./ViewModule.vue?vue&type=script&lang=js"
export * from "./ViewModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports